import FooterSection from './containers/FooterSection';
import Start from './containers/ShinobiStart';
// import FunctionIntroduction from './containers/FunctionIntroduction';
import WalletIntro from './containers/Wallet';
import DownloadApp from './containers/DownloadApp';
import Himegami from './containers/Himegami';
import FunctionApp from './containers/FunctionApp';
import ShinobiTeam from './containers/ShinobiTeam';
import {Blog} from './containers/Blog';
import {MarketPrices} from './containers/MarketPrices';
import {MailSubcription} from './containers/MailSubcription';
import {DownApp2} from './containers/DownApp2';
import {Partners} from './containers/Partners';
import {useMediaQuery, useTheme} from '@material-ui/core';

function Index() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <div
      style={{
        background: matches ? '#fff' : '#fff',
      }}>
      <Start />
      {/* {matches ? <MarketPrices /> : null} */}
      <FunctionApp />
      <MailSubcription />
      <Blog />
      <MarketPrices />
      <DownApp2 />
      <Partners />
    </div>
  );
}

export default Index;
